export const FIELD_NAMES = {
  email: 'email',
  msisdn: 'msisdn',
  otp: 'otp',
  street: 'street',
  streetNumber: 'floor',
  unitNumber: 'door',
  city: 'city',
  province: 'province',
  postcode: 'postcode',
  state: 'state',
  checkbox: 'updateDataConfirmation',
};

export const MSISDN_MASK = '99 9999 9999';
export const OTP_AND_MSISDN_MASK = '9999';

export const GRID_ONE_WHALE = 'grid__item one-whole palm--one-whole';
export const GRID_ONE_HALF_WITH_PADDING_RIGHT = 'grid__item one-half palm--one-half update-data-popup-content__pr-8';
export const GRID_ONE_HALF_WITH_PADDING_LEFT = 'grid__item one-half palm--one-half update-data-popup-content__pl-8';
